window.app.factory("apiFiles", [
  "backend.config",
  "apiCall",
  "$q",
  function(backend, apiCall, $q) {
    const fileDataCache = {};
    const objectUrlCache = {};

    function fetchFile(url) {
      const endpoint = url.replace(/https?:\/\/[^/]+/, "");

      return apiCall({
        endpoint,
        placeholders: false,
        responseType: "blob"
        // unwrap: false,
        // transformResponse: [function (data) {
        //   return data;
        // }],
      }).then(data => {
        fileDataCache[url] = data;
        return data;
      });
    }

    function getLocalURL(apiUrl, type = "news") {
      if (window.isMobileApp) {
        const appender = apiUrl.indexOf("?") === -1 ? "?" : "&";

        // Ad-hoc URL processing by type
        const formatByType = {
          news: url => {
            return url
              .replace("//news", "/news")
              .replace("/news/", "/news/manualimage/");
          }
        };

        const url = formatByType[type](apiUrl);

        return $q.resolve(url + appender + "t=" + backend.token);
      }
      if (objectUrlCache[apiUrl]) {
        return $q.resolve(objectUrlCache[apiUrl]);
      }

      const dataPromise = fileDataCache[apiUrl]
        ? $q.resolve(fileDataCache[apiUrl])
        : fetchFile(apiUrl);

      return dataPromise.then(data => {
        const objUrl = window.URL.createObjectURL(data);
        objectUrlCache[apiUrl] = objUrl;
        return objUrl;
      });
    }

    function freeLocalURL(apiUrl) {
      if (objectUrlCache[apiUrl]) {
        URL.revokeObjectURL(objectUrlCache[apiUrl]);
        delete objectUrlCache[apiUrl];
      }
    }

    return { getLocalURL, freeLocalURL };
  }
]);



// WEBPACK FOOTER //
// ./src/services/apiFiles.js